import { __decorate } from "tslib";
import { Component, Vue } from "vue-property-decorator";
//@ts-ignore
import { AuthenticationContext } from "vue-adal";
//@ts-ignore
import createMockTeam from "../utility/createMockTeam";
//@ts-ignore
import addMockDataToTeam from "../utility/addMockDataToTeam";
//@ts-ignore
import cleanupMockedData from "../utility/cleanupMockedData";
let Token = class Token extends Vue {
    signout() {
        AuthenticationContext.signOut();
    }
    getToken() {
        AuthenticationContext.acquireToken(process.env.VUE_APP_AZURE_CLIENT_ID, (err, token) => {
            if (err) {
                const errCode = err.split(":")[0];
                switch (errCode) {
                    case "AADSTS50058": // Need to prompt for user sign in
                        AuthenticationContext.login();
                        break;
                    case "AADSTS65001": // Token is invalid; grab a new one
                        AuthenticationContext.acquireTokenRedirect(process.env.VUE_APP_AZURE_CLIENT_ID);
                        break;
                    case "AADSTS16000": // No Access
                    default:
                        // Need a pop-up forcing a login
                        AuthenticationContext.login();
                        break;
                }
                return;
            }
            this.$data.token = "Bearer " + token;
        });
    }
    clearStorage() {
        localStorage.clear();
        this.$store.dispatch("ToastMessage", {
            type: "error",
            message: "The local storage has been cleared",
        });
    }
};
Token = __decorate([
    Component({
        data() {
            return {
                token: "",
            };
        },
        created() {
            this.getToken();
        },
        computed: {
            devmode() {
                //@ts-ignore
                return process.env.VUE_APP_SENTRY_ENV !== "production";
            },
        },
        methods: {
            createTeam() {
                createMockTeam();
            },
            createMockReports() {
                addMockDataToTeam();
            },
            cleanup() {
                cleanupMockedData();
            },
        },
    })
], Token);
export default Token;
